module.exports = __webpack_public_path__ + "media/images/category/dummy/outer04-0e1b9ef63fb1b5c96b8f9442ae4e58f2.jpg";